import midjourneyLogo from '../Assets/midjourny_logo.png'
import chatgptLogo from '../Assets/chatgpt_logo.png'
import stableDiffVid from '../Assets/stable_diff.mp4'
import openAiVid from '../Assets/open_ai_reveal.mp4'
import midjoruneyVideoHorizontal from '../Assets/midjourney_vid_horizontal.mp4'
import automationVideo from '../Assets/automationVideo.mp4'
import stableDiffLogo from '../Assets/stable_diffusion_logo.png'

class CourseData {
    constructor() {
        this.courses = [
            {
                title: 'Advanced ChatGPT Course',
                subtitle: 'Writing emails, documents, Excel, and code',
                logo: chatgptLogo,
                image: undefined,
                video: openAiVid,
                duration: '2 hours',
                suggestedParticipants: '15 to 25 people',
                additionalTopics: 'Learning how to create emails, reports, and additional content, utilizing Excel capabilities, writing code, and product creation',
                price: '1,500'
            },
            {
                title: 'Advanced MidJourney Course',
                subtitle: 'Creating images, logos, and advertisements',
                logo: midjourneyLogo,
                image: undefined,
                video: midjoruneyVideoHorizontal,
                duration: '2 hours',
                suggestedParticipants: 'Up to 15 people',
                additionalTopics: 'Creating branded products, logos, and looping or zooming videos',
                price: '1,200'
            },
            {
                title: 'Business Automation Course',
                subtitle: 'Streamlining workflows with AI and automation tools',
                logo: stableDiffLogo, // Replace with your logo
                image: undefined,
                video: automationVideo, // Replace with your video
                duration: '2.5 hours',
                suggestedParticipants: '5 to 10 people',
                additionalTopics: 'Learning how to automate repetitive tasks, integrate AI-driven solutions into daily business operations, and optimize workflows to save time and resources',
                price: '1,800'
            },
            {
                title: 'Advanced Stable Diffusion Course',
                subtitle: 'Creating videos and animations',
                logo: stableDiffLogo,
                image: undefined,
                video: stableDiffVid,
                duration: '4 hours',
                suggestedParticipants: 'Up to 25 people',
                additionalTopics: 'Using various tools to transform videos into different styles and techniques for creating all types of videos',
                price: '1,350'
            },
           
        ];
        
    }

    getCourses() {
        return this.courses;
    }
}

export default new CourseData();
